import { render, staticRenderFns } from "./FShortcut.vue?vue&type=template&id=e32e421a&scoped=true&"
import script from "./FShortcut.vue?vue&type=script&lang=js&"
export * from "./FShortcut.vue?vue&type=script&lang=js&"
import style0 from "./FShortcut.vue?vue&type=style&index=0&id=e32e421a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e32e421a",
  null
  
)

export default component.exports